<template>
  <div id="cardApp" class="app-wrapper">
    <div class="main-wrapper">
      <main class="content-main">
        <img src="@/assets/hktcmbanner.jpg" style="width:100%" />
        <img src="@/assets/hktcmbg.jpg" style="width:100%" />
        
        <div class="page-title-row" style="display: flex; justify-content: space-between; align-items: center;">
          <h3 style="margin: 0;">Prepaid Card Application</h3>
        </div>

        <div class="apply-section">
          <div class="apply-item">
            <div class="apply-info">
              <div class="apply-title">Existing Trust Client Application</div>
            </div>
            <button @click="openAccountDialog" class="apply-btn apply-btn-primary" style="text-decoration: none; border: none; cursor: pointer;">Apply Now</button>
          </div>
        </div>

        <div class="new-user-form-section">
          <div class="form-header">
            <h3>New Trust Client Application</h3>
            <p>Please fill in your contact information below</p>
          </div>
          
          <form @submit.prevent="submitNewUserForm" class="new-user-form">
            <div class="form-group">
              <label class="form-label"><span class="required">*</span> Name</label>
              <input type="text" v-model="newUserForm.name" class="form-input" required placeholder="Please enter your full name" />
            </div>
            <div class="form-group">
              <label class="form-label"><span class="required">*</span> Phone</label>
              <input type="tel" v-model="newUserForm.phone" class="form-input" required placeholder="Please enter your phone number" />
            </div>
            <div class="form-group">
              <label class="form-label"><span class="required">*</span> Email</label>
              <input type="email" v-model="newUserForm.email" class="form-input" required placeholder="Please enter your email address" />
            </div>
            <div class="form-group">
              <label class="form-label">Message <span class="optional">(Optional)</span></label>
              <textarea v-model="newUserForm.message" class="form-textarea" placeholder="Any additional information" rows="4"></textarea>
            </div>
            <div class="form-actions">
              <button type="submit" class="btn-submit">Submit</button>
            </div>
          </form>

          <div class="contact-section">
            <div class="contact-item">
              <span class="contact-icon">📞</span>
              <div class="contact-info">
                <div class="contact-label">Customer Service Hotline</div>
                <div class="contact-value">+852 2752 0313</div>
              </div>
            </div>
            <div class="contact-item">
              <span class="contact-icon">✉️</span>
              <div class="contact-info">
                <div class="contact-label">Email Support</div>
                <div class="contact-value">info@hongkongtrust.com.hk</div>
              </div>
            </div>
            <div class="contact-item">
              <span class="contact-icon">🕐</span>
              <div class="contact-info">
                <div class="contact-label">Service Hours</div>
                <div class="contact-value">Mon-Fri 9:00-18:00 HKT (Excluding Public Holidays)</div>
              </div>
            </div>
          </div>
        </div>

        <div style="margin-top: 20px; padding: 15px; background: #f8f9fa; border-radius: 8px; font-size: 13px; color: #666;">
          Online applications are not processed immediately and should not be used for urgent submissions. For any inquiries, please contact us promptly via email.
        </div>
      </main>
    </div>

    <!-- 登录验证弹窗 -->
    <div v-if="showAccountDialog" class="modal-overlay" @click.self="closeDialog">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Client Verification</h3>
          <button class="modal-close" @click="closeDialog">&times;</button>
        </div>
        
        <!-- 弹窗内的全局提示框 (成功/失败) -->
        <div v-if="dialogMessage.text" :class="['dialog-alert', dialogMessage.type]">
          {{ dialogMessage.text }}
        </div>

        <div class="modal-body">
          <!-- Member ID -->
          <div class="form-group">
            <label class="form-label">Member ID</label>
            <input 
              type="text" 
              v-model="loginForm.memberId" 
              @input="clearError('memberId')"
              class="form-input" 
              :class="{ 'is-error': formErrors.memberId }"
              placeholder="Enter Member ID" 
            />
            <span v-if="formErrors.memberId" class="field-error">{{ formErrors.memberId }}</span>
          </div>

          <!-- Password (带小眼睛切换) -->
          <div class="form-group">
            <label class="form-label">Password</label>
            <div class="password-wrapper">
              <input 
                :type="showPassword ? 'text' : 'password'" 
                v-model="loginForm.password" 
                @input="clearError('password')"
                class="form-input password-input" 
                :class="{ 'is-error': formErrors.password }"
                placeholder="Enter Password" 
              />
              <span class="password-toggle" @click="showPassword = !showPassword" :title="showPassword ? 'Hide Password' : 'Show Password'">
                <svg v-if="!showPassword" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
              </span>
            </div>
            <span v-if="formErrors.password" class="field-error">{{ formErrors.password }}</span>
          </div>

          <!-- Phone Number (使用 datalist 实现原生快速搜索选择) -->
          <div class="form-group">
            <label class="form-label">Phone Number</label>
            <div class="phone-input-group">
              <input 
                type="text" 
                v-model="loginForm.areaCode" 
                @input="clearError('areaCode')"
                list="area-codes-list"
                class="form-input area-code-input"
                placeholder="Code"
                :class="{ 'is-error': formErrors.areaCode }"
              />
              <!-- 原生下拉数据列表，支持输入过滤 -->
              <datalist id="area-codes-list">
                <option v-for="code in areaCodes" :key="code" :value="code">{{ code }}</option>
              </datalist>
              
              <input 
                type="tel" 
                v-model="loginForm.phone" 
                @input="clearError('phone')"
                class="form-input phone-input" 
                :class="{ 'is-error': formErrors.phone }"
                placeholder="Phone Number" 
              />
            </div>
            <span v-if="formErrors.areaCode" class="field-error">{{ formErrors.areaCode }}</span>
            <span v-if="formErrors.phone" class="field-error">{{ formErrors.phone }}</span>
          </div>

          <!-- Verification Code -->
          <div class="form-group">
            <label class="form-label">Verification Code</label>
            <div class="phone-input-group">
              <input 
                type="text" 
                v-model="loginForm.code" 
                @input="clearError('code')"
                class="form-input" 
                :class="{ 'is-error': formErrors.code }"
                placeholder="Verification Code" 
                style="flex: 1;" 
              />
              <button type="button" @click="sendCode" :disabled="isCounting" class="btn-send-code">
                {{ isCounting ? `${countdown}s` : 'Get Code' }}
              </button>
            </div>
            <span v-if="formErrors.code" class="field-error">{{ formErrors.code }}</span>
          </div>
        </div>

        <div class="modal-footer">
          <button @click="closeDialog" class="btn-cancel">Cancel</button>
          <button @click="submitLoginForm" class="btn-submit-modal">Verify & Continue</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 状态码错误提示映射字典
const ERROR_MESSAGES = {
  0: (msg) => msg ? `Incorrect credentials. Attempts remaining: ${msg}` : 'Account or password cannot be empty.',
  10: 'Member ID is incorrect.',
  11: 'Verification code is incorrect.',
  12: 'Verification code has expired.',
  13: 'Login failed. Please check your information.',
  14: 'Account is locked. Please contact customer service or try again tomorrow.',
  15: 'Phone number does not exist.',
  99: 'System is currently upgrading. Please try again later.'
};

export default {
  name: 'CreditCardStatic',
  data() {
    return {
      newUserForm: {
        name: '',
        phone: '',
        email: '',
        message: ''
      },
      showAccountDialog: false,
      showPassword: false, // 控制密码显示/隐藏
      loginForm: {
        memberId: '',
        password: '',
        areaCode: '',
        phone: '',
        code: ''
      },
      formErrors: {
        memberId: '',
        password: '',
        areaCode: '',
        phone: '',
        code: ''
      },
      dialogMessage: {
        type: '',
        text: ''
      },
      areaCodes: [],
      countdown: 0,
      isCounting: false,
      timer: null
    }
  },
  methods: {
    closeDialog() {
      this.showAccountDialog = false;
      this.resetFormState();
    },
    resetFormState() {
      this.loginForm = { memberId: '', password: '', areaCode: '', phone: '', code: '' };
      this.formErrors = { memberId: '', password: '', areaCode: '', phone: '', code: '' };
      this.dialogMessage = { type: '', text: '' };
      this.showPassword = false;
      this.countdown = 0;
      this.isCounting = false;
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    clearError(field) {
      this.formErrors[field] = '';
      this.dialogMessage.text = ''; 
    },
    openAccountDialog() {
      this.resetFormState();
      this.showAccountDialog = true;
      this.fetchAreaCodes();
    },
    
    getErrorMessage(status, message) {
      const handler = ERROR_MESSAGES[status];
      if (typeof handler === 'function') {
        return handler(message);
      }
      return handler || message || 'Unknown error occurred.';
    },

    async fetchAreaCodes() {
      try {
        // 🌟 生产环境：使用完整的绝对 URL
        const response = await fetch('https://member.hongkongtrust.com.hk/api/login/areaCode');
        const result = await response.json();
        if (result.status === 1) {
          const rawCodes = result.data.map(item => item.calling_code);
          // 核心修复：使用 Set 去重，彻底解决后端返回重复区号导致的卡死问题
          this.areaCodes = [...new Set(rawCodes)];
          
          if (this.areaCodes.length > 0 && !this.loginForm.areaCode) {
            this.loginForm.areaCode = this.areaCodes.includes('+852') ? '+852' : this.areaCodes[0];
          }
        }
      } catch (error) {
        console.error('Failed to fetch area codes', error);
        this.dialogMessage = { type: 'error', text: 'Failed to load area codes. Please check network.' };
      }
    },
    
    getBasePayload() {
      return {
        membership_number: this.loginForm.memberId,
        clients_password: this.loginForm.password,
        captcha_req: 1,
        area_code: this.loginForm.areaCode.replace(/^\+/, ''),
        phone_number: this.loginForm.phone
      };
    },

    validateBeforeCode() {
      let isValid = true;
      this.formErrors = { memberId: '', password: '', areaCode: '', phone: '', code: '' };

      if (!this.loginForm.memberId.trim()) {
        this.formErrors.memberId = 'Member ID is required.';
        isValid = false;
      }
      if (!this.loginForm.password) {
        this.formErrors.password = 'Password is required.';
        isValid = false;
      }
      // 严格校验：用户输入或选择的区号必须存在于我们获取的合法列表中
      if (!this.loginForm.areaCode || !this.areaCodes.includes(this.loginForm.areaCode)) {
        this.formErrors.areaCode = 'Please select a valid area code from the list.';
        isValid = false;
      }
      if (!this.loginForm.phone.trim()) {
        this.formErrors.phone = 'Phone number is required.';
        isValid = false;
      }
      
      this.dialogMessage = { type: '', text: '' };
      return isValid;
    },

    async sendCode() {
      if (!this.validateBeforeCode()) return;
      
      this.countdown = 60;
      this.isCounting = true;
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.timer);
          this.isCounting = false;
        }
      }, 1000);

      try {
        const payload = this.getBasePayload();
        // 🌟 生产环境：使用完整的绝对 URL
        const response = await fetch('https://member.hongkongtrust.com.hk/api/misc/check', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        const result = await response.json();
        
        if (result.status === 1) {
          this.dialogMessage = { type: 'success', text: 'Verification code sent successfully.' };
        } else {
          this.dialogMessage = { type: 'error', text: this.getErrorMessage(result.status, result.message) };
          clearInterval(this.timer);
          this.isCounting = false;
          this.countdown = 0;
        }
      } catch (error) {
        console.error('Send code error:', error);
        this.dialogMessage = { type: 'error', text: 'Network error. Please try again.' };
        clearInterval(this.timer);
        this.isCounting = false;
        this.countdown = 0;
      }
    },

    async submitLoginForm() {
      if (!this.validateBeforeCode()) return;
      
      if (!this.loginForm.code.trim()) {
        this.formErrors.code = 'Verification code is required.';
        this.dialogMessage = { type: '', text: '' };
        return;
      }

      try {
        const payload = {
          ...this.getBasePayload(),
          captcha: this.loginForm.code
        };

        // 🌟 生产环境：使用完整的绝对 URL
        const response = await fetch('https://member.hongkongtrust.com.hk/api/misc/check', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        const result = await response.json();
        
        if (result.status === 1 && result.data && result.data.token) {
          let finalToken = '';
          try {
            const tokenObj = JSON.parse(result.data.token);
            finalToken = tokenObj.token;
          } catch (e) {
            finalToken = result.data.token;
          }

          this.dialogMessage = { type: 'success', text: 'Verification successful! Redirecting...' };
          setTimeout(() => {
            window.location.href = `https://visa.hkssa.top/apply/${finalToken}`;
          }, 800); 
        } else {
          this.dialogMessage = { type: 'error', text: this.getErrorMessage(result.status, result.message) };
        }
      } catch (error) {
        console.error('Verify error:', error);
        this.dialogMessage = { type: 'error', text: 'Network error. Please try again later.' };
      }
    },

    async submitNewUserForm() {
      if (!this.newUserForm.name || !this.newUserForm.phone || !this.newUserForm.email) {
        this.$message.warning('Please fill in all required fields.');
        return;
      }
      try {
        const response = await fetch('https://htkcmvisa.giize.com/submit_application.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(this.newUserForm)
        });
        const result = await response.json();
        if (result.status === 1) {
          this.$message.success('Thank you! Your application has been submitted successfully.');
          this.newUserForm = { name: '', phone: '', email: '', message: '' };
        } else {
          this.$message.error(result.message || 'Submission failed');
        }
      } catch (error) {
        console.error('Submission error:', error);
        this.$message.error('Network error. Please try again later.');
      }
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}
</script>

<style>
/* 样式部分保持与之前完全一致，确保 UI 体验不变 */
:root {
  --bg-light: #f8f9fc;
  --primary-color: #1E3A8A;
  --primary-hover: #3B82F6;
  --accent-color: #F59E0B;
  --border-color: #cbd5e1;
  --border-color-dark: #94a3b8;
  --text-primary: #1E293B;
  --text-secondary: #64748B;
  --text-error: #EF4444;
  --text-success: #10b981;
  --bg-white: #fff;
  --bg-gray: #f8f9fa;
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --radius-sm: 6px;
  --radius-md: 8px;
  --radius-lg: 12px;
}

body, html { 
  margin: 0; padding: 0; height: 100%; 
  font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; 
  background-color: var(--bg-light); 
  overflow: hidden; 
}

.app-wrapper { display: flex; height: 100vh; }
.main-wrapper { flex: 1; display: flex; flex-direction: column; overflow: hidden; position: relative; }
.content-main { flex: 1; padding: 25px; overflow-y: auto; }

.apply-section { 
  background: white; 
  border-radius: var(--radius-lg); 
  padding: 25px; 
  box-shadow: var(--shadow-md); 
  margin-top: 20px; 
  border: 1px solid var(--border-color);
}

.apply-item { 
  display: flex; 
  justify-content: space-between; 
  align-items: center; 
  padding: 20px 0; 
  border-bottom: 1px solid var(--border-color); 
}
.apply-item:last-child { border-bottom: none; }

.apply-info { flex: 1; text-align: left; }
.apply-title { font-weight: 600; font-size: 16px; color: var(--text-primary); margin-bottom: 5px; }

.apply-btn { 
  min-width: 140px; 
  padding: 12px 24px; 
  border-radius: var(--radius-md); 
  font-weight: 500; 
  cursor: pointer; 
  text-align: center; 
  transition: all 0.3s ease; 
  font-size: 14px;
}

.apply-btn-primary { 
  background-color: var(--primary-color); 
  color: white; 
  border: 2px solid var(--primary-color); 
}
.apply-btn-primary:hover { 
  background-color: var(--primary-hover); 
  border-color: var(--primary-hover);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.new-user-form-section {
  background: white;
  border-radius: var(--radius-lg);
  padding: 40px;
  box-shadow: var(--shadow-md);
  margin-top: 20px;
  border: 2px solid var(--border-color);
}

.form-header {
  margin-bottom: 35px;
  text-align: left;
  padding-bottom: 20px;
  border-bottom: 3px solid var(--border-color);
}

.form-header h3 {
  margin: 0 0 8px 0;
  color: var(--primary-color);
  font-size: 24px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 10px;
}

.form-header h3::before {
  content: '';
  display: inline-block;
  width: 5px;
  height: 30px;
  background: var(--accent-color);
  border-radius: 2px;
}

.form-header p {
  margin: 0;
  color: var(--text-secondary);
  font-size: 14px;
  line-height: 1.6;
}

.new-user-form {
  max-width: 700px;
  margin: 0 auto;
}

.form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;
  position: relative;
}

.form-label {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 4px;
  text-align: left;
}

.form-label .required {
  color: var(--text-error);
  font-size: 18px;
  line-height: 1;
}

.form-label .optional {
  color: var(--text-secondary);
  font-weight: 400;
  font-size: 13px;
}

.form-input, .form-textarea {
  padding: 14px 16px;
  border: 2px solid var(--border-color);
  border-radius: var(--radius-md);
  font-size: 15px;
  color: var(--text-primary);
  transition: all 0.3s ease;
  background-color: var(--bg-white);
  width: 100%;
  box-sizing: border-box;
}

.form-input::placeholder, .form-textarea::placeholder {
  color: #94a3b8;
}

.form-input:focus, .form-textarea:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 4px rgba(30, 58, 138, 0.1);
  transform: translateY(-1px);
}

.form-input:hover:not(:focus), .form-textarea:hover:not(:focus) {
  border-color: var(--border-color-dark);
}

.form-textarea {
  resize: vertical;
  min-height: 120px;
  font-family: inherit;
}

.form-input.is-error {
  border-color: var(--text-error);
}
.form-input.is-error:focus {
  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.1);
}

.field-error {
  color: var(--text-error);
  font-size: 13px;
  margin-top: 6px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.field-error::before {
  content: '⚠';
  font-size: 14px;
}

.form-actions {
  display: flex;
  justify-content: flex-start;
  margin-top: 35px;
  padding-top: 25px;
  border-top: 3px solid var(--border-color);
}

.btn-submit {
  padding: 15px 40px;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-hover) 100%);
  color: white;
  border: 2px solid var(--primary-color);
  border-radius: var(--radius-md);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  box-shadow: var(--shadow-md);
  position: relative;
  overflow: hidden;
}

.btn-submit:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
  border-color: var(--primary-hover);
}

.contact-section {
  margin-top: 30px;
  padding: 20px 25px;
  background: linear-gradient(135deg, #f8f9fc 0%, #eef2f7 100%);
  border-radius: var(--radius-md);
  border: 1px solid var(--border-color);
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
}

.contact-icon {
  font-size: 20px;
  flex-shrink: 0;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.contact-label {
  font-size: 12px;
  color: var(--text-secondary);
  font-weight: 500;
}

.contact-value {
  font-size: 14px;
  color: var(--primary-color);
  font-weight: 600;
  font-family: "SimSun", "Songti SC", serif !important;
  font-variant-numeric: tabular-nums;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease;
}

.modal-content {
  background: white;
  border-radius: var(--radius-lg);
  width: 90%;
  max-width: 450px;
  box-shadow: var(--shadow-lg);
  animation: fadeIn 0.3s ease;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px;
  border-bottom: 1px solid var(--border-color);
  flex-shrink: 0;
}

.modal-header h3 {
  margin: 0;
  color: var(--primary-color);
  font-size: 18px;
  font-weight: 600;
}

.modal-close {
  background: none;
  border: none;
  font-size: 24px;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.modal-close:hover {
  color: var(--text-error);
}

.dialog-alert {
  margin: 15px 25px 0;
  padding: 12px 16px;
  border-radius: var(--radius-md);
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  animation: fadeIn 0.3s ease;
}

.dialog-alert.success {
  background-color: #ecfdf5;
  color: #065f46;
  border: 1px solid #a7f3d0;
}

.dialog-alert.success::before {
  content: '✓';
  font-weight: bold;
  font-size: 16px;
}

.dialog-alert.error {
  background-color: #fef2f2;
  color: #991b1b;
  border: 1px solid #fecaca;
}

.dialog-alert.error::before {
  content: '✕';
  font-weight: bold;
  font-size: 16px;
}

.modal-body {
  padding: 25px;
  flex: 1;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 15px 25px 25px;
  border-top: 1px solid var(--border-color);
  flex-shrink: 0;
}

.btn-cancel {
  padding: 10px 20px;
  background-color: white;
  color: var(--text-secondary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-cancel:hover {
  background-color: var(--bg-gray);
  border-color: var(--border-color-dark);
}

.btn-submit-modal {
  padding: 10px 24px;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: var(--radius-md);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-submit-modal:hover {
  background-color: var(--primary-hover);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.phone-input-group {
  display: flex;
  gap: 10px;
}

/* 区号输入框样式 (与之前的 select 宽度保持一致) */
.area-code-input {
  width: 110px;
  flex-shrink: 0;
}

.phone-input {
  flex: 1;
}

.btn-send-code {
  padding: 0 15px;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: var(--radius-md);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
}

.btn-send-code:disabled {
  background-color: #94a3b8;
  cursor: not-allowed;
}

.btn-send-code:hover:not(:disabled) {
  background-color: var(--primary-hover);
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

/* ========== 密码小眼睛专属样式 ========== */
.password-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input {
  padding-right: 45px !important; 
  width: 100%;
}

.password-toggle {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
  z-index: 2;
}

.password-toggle:hover {
  color: var(--primary-color);
}

@media (max-width: 768px) {
  .apply-item { flex-direction: column; align-items: flex-start; gap: 15px; }
  .new-user-form-section { padding: 25px; }
  .form-header h3 { font-size: 20px; }
  .btn-submit { width: 100%; justify-content: center; }
  .contact-section { grid-template-columns: 1fr; padding: 15px; }
  .contact-item { padding: 10px 0; border-bottom: 1px dashed var(--border-color); }
  .contact-item:last-child { border-bottom: none; }
}
</style>